<div class="row vh-100">
    <div class="col-lg-6 col-md-12 p-3 onboarding-banner-section">
        <app-onboarding-banner [currentStep]="1"></app-onboarding-banner>
    </div>
    <div class="col-lg-6 col-md-12 p-3">
        <div class="onboarding-container">
            <div class="onboarding">
                <div class="logo-container">
                    <a href="https://www.expenseondemand.com/">
                        <img src="../../assets/images/logo.svg"
                            alt="Expense On Demand" width="140px" />
                    </a>
                </div>
                @if(state === 'login'){
                    <div class="one-col-grid">
                        <p class="onboarding-subtitle" id="pliant-connect-login-note">{{ 'pliant_connect_login_note' | translate: { name: organizationName } }}</p>
                        <app-login-new></app-login-new>
                    </div>
                }
                @if(state === 'connecting'){
                    <div class="one-col-grid" id="pliant-connect-connecting">
                        <h5 class="onboarding-title">{{ 'pliant_connect_title' | translate }}</h5>
                        <p class="onboarding-subtitle">{{ 'pliant_connecting' | translate: { name: organizationName } }}</p>
                    </div>
                }
                @if(state === 'success'){
                    <div class="one-col-grid" id="pliant-connect-success">
                        <h5 class="onboarding-title">{{ 'pliant_connect_title' | translate }}</h5>
                        <p class="onboarding-subtitle">{{ 'pliant_connect_success' | translate }}</p>
                        <p class="onboarding-subtitle">{{ 'pliant_redirecting_back' | translate: { seconds: redirectCountdown } }}</p>
                        <a class="link" id="pliant-return-link" (click)="returnToPliant()">{{ 'pliant_return_to_pliant' | translate }}</a>
                    </div>
                }
                @if(state === 'error'){
                    <div class="one-col-grid" id="pliant-connect-error">
                        <h5 class="onboarding-title">{{ 'pliant_connect_title' | translate }}</h5>
                        <p class="onboarding-subtitle">{{ 'pliant_connect_error' | translate }}</p>
                        @if(returnUrl){
                            <p class="onboarding-subtitle">{{ 'pliant_redirecting_back' | translate: { seconds: redirectCountdown } }}</p>
                            <a class="link" id="pliant-return-link" (click)="returnToPliant()">{{ 'pliant_return_to_pliant' | translate }}</a>
                        }
                    </div>
                }
                @if(state === 'notAllowed'){
                    <div class="one-col-grid" id="pliant-connect-not-allowed">
                        <h5 class="onboarding-title">{{ 'pliant_connect_title' | translate }}</h5>
                        <p class="onboarding-subtitle">{{ 'pliant_connect_not_allowed' | translate }}</p>
                        @if(returnUrl){
                            <a class="link" id="pliant-return-link" (click)="returnToPliant()">{{ 'pliant_return_to_pliant' | translate }}</a>
                        }
                    </div>
                }
                @if(state === 'invalid'){
                    <div class="one-col-grid" id="pliant-connect-invalid">
                        <h5 class="onboarding-title">{{ 'pliant_connect_title' | translate }}</h5>
                        <p class="onboarding-subtitle">{{ 'pliant_connect_invalid_link' | translate }}</p>
                    </div>
                }
            </div>
            <div class="one-col-grid align-items-center gap-4">
                <p class="copyright-text">{{'copyright_expense_on_demand' | translate}}</p>
                <p class="copyright-text">{{'do_not_store_credit_card_details' | translate}}</p>
            </div>
        </div>
    </div>
</div>
